import { Button, Table, Tag, message } from "antd";
import { useEffect, useState } from "react";
import Url from "../../../apiCall/UrlConfig";
///redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useNavigate } from "react-router-dom";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const OpgMainPage = (props) => {
  let navigate = useNavigate();
  const [_paging, setPaging] = useState({ pageNumber: 1, pageSize: 10 });
  const Columns = [
    {
      title: "Patien Id",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        return <div style={{ textAlign: "center" }}>{item.id}</div>;
      },
    },
    // {
    //   title: "Patien Age",
    //   dataIndex: "maxilla",
    //   key: "maxilla",
    //   render: (obj, item, index) => {
    //     return <div style={{ textAlign: "center" }}>{item.age}</div>;
    //   },
    // },
    {
      title: "maxilla",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "maxilla");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="maxilla"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "mandible",
      dataIndex: "mandible",
      key: "mandible",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "mandible");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="mandible"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "Opg",
      dataIndex: "OPG",
      key: " opganalyse",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "opg");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="opganalyse"
              style={{ width: "70px" }}
            />
            <div></div>
          </>
        );
      },
    },
    {
      title: "Analyses",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        if (item?.hasOpgAnalyse) {
          return (
            <>
              <Tag color="#87d068">Analyses Done</Tag>
              <div>Age={item.age}</div>
            </>
          );
        }
        return (
          <Button onClick={() => _onClickAnalyses(item.id)}>Analyses</Button>
        );
      },
    },
  ];
  const _getListPatient = async (paging) => {
    let _paging = paging;

    if (paging == null) {
      _paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    let url = Url.getPatientForOpg;

    let res = await props.actions.CallCoreServicesActionWithToken(url, _paging);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  useEffect(async () => {
    let paging = await JSON.parse(localStorage.getItem("@opgAnalysesPaging"));
    if (paging == null) {
      paging = {
        pageNumber: 1,
        pageSize: 10,
      };
    }
    setPaging(paging);
    _getListPatient(paging);
  }, []);

  const _onClickAnalyses = (id) => {
    navigate(`/opganalyse/analyses/${id}`);
  };
  const _onChangePageSize = (pageNumber, pageSize) => {
    localStorage.setItem(
      "@opgAnalysesPaging",
      JSON.stringify({
        pageNumber,
        pageSize,
      })
    );
    setPaging({ pageNumber, pageSize });
    _getListPatient({
      pageNumber,
      pageSize,
    });
  };
  return (
    <div>
      <Table
        columns={Columns}
        dataSource={
          props.coreData[Url.getPatientForOpg]?.[Url.action]?.data?.patients
        }
        loading={props.coreData[Url.getPatientForOpg]?.[Url.action]?.isFetching}
        pagination={{
          current: _paging.pageNumber,
          pageSize: _paging.pageSize,
          total:
            props.coreData[Url.getPatientForOpg]?.[Url.action]?.data
              ?.totalCount,
          onChange: _onChangePageSize,
        }}
        rowKey={(o) => o.id}
      />
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(OpgMainPage);
